/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Synthflow Backend
 * OpenAPI spec version: 1.0
 */

export type TransferCallActionType =
  (typeof TransferCallActionType)[keyof typeof TransferCallActionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferCallActionType = {
  transfer: "transfer",
} as const;
